import {
    FETCH_FABRIC_MASTER_REQUEST,
    FETCH_FABRIC_MASTER_SUCCESS,
    FETCH_FABRIC_MASTER_FAILURE,
    CREATE_FABRIC_MASTER_FORM,
    UPDATE_FABRIC_MASTER_FORM,
    CREATE_FABRIC_MASTER_SUCCESS,
    FETCH_SINGLE_FABRIC_MASTER_SUCCESS,
    UPDATE_FABRIC_MASTER_SUCCESS,
    DELETE_FABRIC_MASTER_SUCCESS,
    CREATE_FABRIC_MASTER_REQUEST,
    UPDATE_FABRIC_MASTER_REQUEST,
    FETCH_SINGLE_FABRIC_MASTER_REQUEST,
    DELETE_FABRIC_MASTER_REQUEST,
    RESET_FABRIC_MASTER_INFO,
    CREATE_FABRIC_MASTER_FAILURE,
    UPDATE_FABRIC_MASTER_FAILURE,
    FETCH_SINGLE_FABRIC_MASTER_FAILURE,
    DELETE_FABRIC_MASTER_FAILURE,
    FETCH_FABRIC_MASTER_WITH_YARN_GROUP_REQUEST,
    FETCH_FABRIC_MASTER_WITH_YARN_GROUP_SUCCESS,
    FETCH_FABRIC_MASTER_WITH_YARN_GROUP_FAILURE,
    FETCH_FABRIC_MASTER_YARN_MATERIAL_REQUEST,
    FETCH_FABRIC_MASTER_YARN_MATERIAL_SUCCESS,
    FETCH_FABRIC_MASTER_YARN_MATERIAL_FAILURE
} from './fabricMaster.actionsType';

export const FABRIC_MASTER = 'fabricMaster';

let initialState = {
    loading: false,
    fabricMasterList: [],
    fabricMasterListWithYarnGroup: [],
    fabricMasterYarnMaterial: [],
    fabricMasterForm: {},
    selectedState: {},
    errorMessage: ''
};

export let fabricMasterReducer = (state = initialState, action) => {
    let { type, updatePayload, payload } = action;

    switch (type) {
        case FETCH_FABRIC_MASTER_REQUEST:
        case FETCH_FABRIC_MASTER_YARN_MATERIAL_REQUEST:
        case FETCH_FABRIC_MASTER_WITH_YARN_GROUP_REQUEST:
        case CREATE_FABRIC_MASTER_REQUEST:
        case UPDATE_FABRIC_MASTER_REQUEST:
        case FETCH_SINGLE_FABRIC_MASTER_REQUEST:
        case DELETE_FABRIC_MASTER_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_FABRIC_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                fabricMasterList: updatePayload
            };
        case FETCH_FABRIC_MASTER_YARN_MATERIAL_SUCCESS:
            return {
                ...state,
                loading: false,
                fabricMasterYarnMaterial: updatePayload
            };
        case FETCH_FABRIC_MASTER_WITH_YARN_GROUP_SUCCESS:
            return {
                ...state,
                loading: false,
                fabricMasterListWithYarnGroup: updatePayload
            };

        case CREATE_FABRIC_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                fabricMasterForm: {}
            };
        case UPDATE_FABRIC_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                fabricMasterForm: {}
            };
        case FETCH_SINGLE_FABRIC_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                fabricMasterForm: updatePayload
            };
        case DELETE_FABRIC_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                fabricMasterForm: {}
            };
        case RESET_FABRIC_MASTER_INFO:
            return {
                ...state,
                fabricMasterForm: {}
            };
        case CREATE_FABRIC_MASTER_FORM:
        case UPDATE_FABRIC_MASTER_FORM:
            return {
                ...state,
                loading: false,
                fabricMasterForm: {
                    ...state.fabricMasterForm,
                    [payload.key]: payload.value
                }
            };
        case FETCH_FABRIC_MASTER_FAILURE:
        case FETCH_FABRIC_MASTER_YARN_MATERIAL_FAILURE:
        case FETCH_FABRIC_MASTER_WITH_YARN_GROUP_FAILURE:
        case CREATE_FABRIC_MASTER_FAILURE:
        case UPDATE_FABRIC_MASTER_FAILURE:
        case FETCH_SINGLE_FABRIC_MASTER_FAILURE:
        case DELETE_FABRIC_MASTER_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
